export default __webpack_public_path__ + "static/media/gitBgImage.8d70ff81.png";